import React from 'react';

/** Standard symbols for controls that previously used font-dependent glyphs. */
export function ActionSymbol({ name }: { name: 'add' | 'remove' | 'close' }) {
  const path = name === 'close' ? 'm6 6 12 12M18 6 6 18' : name === 'add' ? 'M12 5v14M5 12h14' : 'M5 12h14';
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true" focusable="false"><path d={path} /></svg>;
}
